/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_Fill_FormInputs */

const en_register_onboarding_personal_info_fill_form = /** @type {(inputs: Register_Onboarding_Personal_Info_Fill_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please fill out the form completely.`)
};

const de_register_onboarding_personal_info_fill_form = /** @type {(inputs: Register_Onboarding_Personal_Info_Fill_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte fülle das Formular vollständig aus.`)
};

/**
* | output |
* | --- |
* | "Please fill out the form completely." |
*
* @param {Register_Onboarding_Personal_Info_Fill_FormInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_fill_form = /** @type {((inputs?: Register_Onboarding_Personal_Info_Fill_FormInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_Fill_FormInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_fill_form(inputs)
	return en_register_onboarding_personal_info_fill_form(inputs)
});